import axios from "axios"

export const updateUserPassword = async (userId: string, password: string) => {
  try {
    const res = await axios.patch(`/users/${userId}`, { password }, { params: { forAdmin: 1 } })
    return res.data
  } catch (err) {
    console.log("updateUserPassword err", err)
    throw err
  }
}
